import axios from 'axios';

import appSettings from '../app-settings';

const API_URL = `${appSettings.baseUrl}/notifications`;

export const getNotificationPreferences = async () => {
  const response = await axios.get(`${API_URL}/preferences`);
  return response.data.preferences;
};

export const updateNotificationPreferences = async (preferences) => {
  const response = await axios.patch(`${API_URL}/preferences`, { preferences });
  return response.data.preferences;
};
